<template>
  <div class="home">
    <div class="box" @mousedown="sbuMousedown">
      <img
        v-for="(item, index) in list"
        :class="listIndex == index?'show':''"
        :key="index"
        :src="item"
      />
      <!-- <p class="left" @click="changePage(prevIndex)">&lt;</p>
      <ul>
        <li
          :class="{ color: index == listIndex }"
          v-for="(item, index) in list"
          @click="changePage(index)"
          :key="index"
        ></li>
      </ul>
      <p class="right" @click="changePage(nextIndex)">&gt;</p> -->
    </div>
  </div>
</template>

<script>
  import svgIcon from './plugins/svgIcon.vue'
	export default {
  components: { svgIcon },
		name: 'SwiPer',
		props: {
      list:{
        type:Array,
        default:[],
        require:true
      }
    },
		data() {
			return{
				listIndex: 0, //默认显示第几张图片
        timer: null, //定时器
			}
		},
		computed: {
    //上一张
      prevIndex() {
        if (this.listIndex == 0) {
          return this.list.length - 1;
        } else {
          return this.listIndex - 1;
        }
      },
      //下一张
      nextIndex() {
        if (this.listIndex == this.list.length - 1) {
          return 0;
        } else {
          return this.listIndex + 1;
        }
      },
    },
		created() {
      this.setTimer();
		},
		mounted() {
    },
		methods:{
    sbuMousedown(){
      if(this.listIndex == 0){
        this.listIndex = 1
      }else{
        this.listIndex = 0
      }
    },
    changePage(index) {
      this.listIndex = index;
    },
    out() {
      this.setTimer();
    },
    over() {
      clearInterval(this.timer);
    },
    setTimer() {
      this.timer = setInterval(() => {
        this.listIndex++;
        if (this.listIndex == this.list.length) {
          this.listIndex = 0;
        }
      this.$emit('getStudent',this.listIndex)
      }, 5000);
    },
		}
	}
</script>
<style scoped>
  .box{
    display: flex;
    position: relative;
  }
	.box img{
    width: 100%;
    min-width: 100%;
    transition: all 2s;
    position: relative;
    left: 0px;
  }
  .box img.show{
    opacity: 1;
    position: absolute;
    left: -100vw;
    top: 0;
  }
</style>
